var exports = {
  "y9": "DMChannelView.module__ravenDm___aDZ2a0",
  "p$": "DMChannelView.module__emptyState___aDZ2a0",
  "AI": "DMChannelView.module__emptyStateIcon___aDZ2a0",
  "vo": "DMChannelView.module__emptyStateTitle___aDZ2a0",
  "Li": "DMChannelView.module__emptyStateDescription___aDZ2a0",
  "fX": "DMChannelView.module__callParticipantsRow___aDZ2a0",
  "gN": "DMChannelView.module__compactCallParticipantsRow___aDZ2a0",
  "Gr": "DMChannelView.module__callParticipant___aDZ2a0",
  "Gj": "DMChannelView.module__callParticipantAvatar___aDZ2a0",
  "I9": "DMChannelView.module__callParticipantRinging___aDZ2a0",
  "rV": "DMChannelView.module__call-participant-ring-pulse___aDZ2a0",
  "Jn": "DMChannelView.module__callBanner___aDZ2a0",
  "nY": "DMChannelView.module__callBannerBody___aDZ2a0",
  "c7": "DMChannelView.module__callBannerResizable___aDZ2a0",
  "oo": "DMChannelView.module__callControlBarSection___aDZ2a0",
  "Pf": "DMChannelView.module__callControlBarInner___aDZ2a0",
  "tX": "DMChannelView.module__callControls___aDZ2a0",
  "pm": "DMChannelView.module__callBannerMobile___aDZ2a0",
  "h8": "DMChannelView.module__callBannerMobileLabel___aDZ2a0",
  "ZI": "DMChannelView.module__callControlsMobile___aDZ2a0",
  "IX": "DMChannelView.module__compactCallResizeHandle___aDZ2a0",
  "rF": "DMChannelView.module__compactCallResizePill___aDZ2a0",
};

module.exports = exports;
